module.exports = __webpack_public_path__ + "img/img-hero-mobile@2x.3c1c72b0.jpg";